import { render, staticRenderFns } from "./ConfigPaymentDeleteDialog.vue?vue&type=template&id=0b7237f0"
import script from "./ConfigPaymentDeleteDialog.vue?vue&type=script&lang=js"
export * from "./ConfigPaymentDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports